@if (recht.mCapititel.access === "NONE") {
  <div class="mb-2">
    <span>{{ "gemaessGrundbuch" | translate }}</span>
  </div>
} @else {
  @if (!recht || !recht.capititel || recht.capititel.length == 0) {
    <div class="mb-2">
      <span>{{ "Keine" | translate }}</span>
    </div>
  } @else {
    <table [attr.aria-label]="'Pfandtitel' | translate" [title]="'Pfandtitel' | translate" class="cap-table-detail">
      <thead>
        <tr>
          <th>{{ "Nummer" | translate }}</th>
          <th>{{ "TiteleingangGrundbuch" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (titel of recht?.capititel; track titel) {
          <tr>
            <td [capHistinfo]="titel.histInfo">{{ titel | kompaktCapititel }}</td>
            <td>{{ getTiteleingang(titel) }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
}

<ng-template #capititel>
  @if (!recht || !recht.capititel || recht.capititel.length == 0) {
    <div class="mb-2">
      <span>{{ "Keine" | translate }}</span>
    </div>
  } @else {
    <table [attr.aria-label]="'Pfandtitel' | translate" [title]="'Pfandtitel' | translate" class="cap-table-detail">
      <thead>
        <tr>
          <th>{{ "Nummer" | translate }}</th>
          <th>{{ "TiteleingangGrundbuch" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (titel of recht?.capititel; track titel) {
          <tr>
            <td [capHistinfo]="titel.histInfo">{{ titel | kompaktCapititel }}</td>
            <td>{{ getTiteleingang(titel) }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</ng-template>

<ng-template #table>
  <table [attr.aria-label]="'Pfandtitel' | translate" [title]="'Pfandtitel' | translate" class="cap-table-detail">
    <thead>
      <tr>
        <th>{{ "Nummer" | translate }}</th>
        <th>{{ "TiteleingangGrundbuch" | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (titel of recht?.capititel; track titel) {
        <tr>
          <td [capHistinfo]="titel.histInfo">{{ titel | kompaktCapititel }}</td>
          <td>{{ getTiteleingang(titel) }}</td>
        </tr>
      }
    </tbody>
  </table>
</ng-template>
